import { getBiggerDateArray } from "./initializerHelpers";

export const getGrupoProdutosOptions = (pesquisas) => {
  if (!pesquisas) return [];
  const uniqueValues = pesquisas.reduce((acc, item) => {
    const grupoProdutoId = item.grupoProduto.id;
    if (grupoProdutoId && !acc[grupoProdutoId])
      acc[grupoProdutoId] = {
        nome: item.grupoProduto.nome,
        codigo: item.grupoProduto.codigo,
        id: grupoProdutoId
      };

    return acc;
  }, {});
  return uniqueValues;
};

export const getProdutoOptions = (pesquisas) => {
  if (!pesquisas) return [];

  const obj = pesquisas.reduce((acc, item) => {
    const produtoId = item.produto.id;
    if (!acc[produtoId]) {
      acc[produtoId] = {
        grupoProdutoId: item.produto.grupoProdutoId,
        descricaoProduto: item.produto.nome || item.produto.descricaoProduto,
        codigo: item.produto.codigo,
        id: produtoId
      };
    }
    return acc;
  }, {});
  return obj;
};


export const getPlayersAmount = (pesquisas) => {
  if (!pesquisas) return [];

  const first = pesquisas.length > 0 ? pesquisas[0] : null;

  if(!first) return [];

  const { lastDate } = getBiggerDateArray({data: first.dates});

  return [...new Set(
    pesquisas
    .filter(el => {
      const indexOfLastDate = el.dates.indexOf(lastDate);
      return el.data[indexOfLastDate];
    })
    .map((item) => item.player))];
};

export const getPlayersAmountNew = (pesquisas) => {
  const playersIds = new Set();
  for (const {pesquisaPlayerId} of pesquisas) {
    playersIds.add(pesquisaPlayerId);
  }

  return playersIds.size;
}

export const getVolumePotencial = (pesquisas) => {
  if (!pesquisas) return [];

  let biggerDate = null;
  let datesValues = {};

  pesquisas.forEach(pesquisa => {
    for(const [key, value] of Object.entries(pesquisa.volumeAtivoPorMes)){
      const currentDate = new Date(key);
      if (biggerDate === null || currentDate > new Date(biggerDate)) {
        biggerDate = currentDate;
      }

      if(datesValues[key] == undefined){
        datesValues[key] = [value];
      }else{
        datesValues[key].push(value);
      }
    }
  });

  if (biggerDate !== null) {
    const formattedDate = new Date(biggerDate).toISOString().split('T')[0];

    return datesValues[formattedDate].reduce((total, item) => {
        return total + item;
      }, 0).toFixed(2);
  }else{
    return 0.0;
  }
};